import { useEffect, useState } from 'react';
import { Navigate, useParams } from 'react-router-dom';
import { fetchWithAuth } from '../utils/fetchWithAuth';
import { API_BASE_URL } from '../config';
import LoadingSpinner from './LoadingSpinner';
import QuotationDetail from './QuotationDetails';

/**
 * Legacy /quotation/:id/:dateCreated/:Qid entry point.
 * Redirects into the shared Service Plan / Quote shell when a care_plan_id exists.
 */
function QuotationToShellRedirect() {
    const { id, Qid } = useParams();
    const [state, setState] = useState({ loading: true, carePlanId: null, error: false });

    useEffect(() => {
        let cancelled = false;

        const resolve = async () => {
            if (!Qid) {
                if (!cancelled) setState({ loading: false, carePlanId: null, error: true });
                return;
            }
            try {
                const response = await fetchWithAuth(`${API_BASE_URL}/quotations/${Qid}`);
                if (!response.ok) {
                    if (!cancelled) setState({ loading: false, carePlanId: null, error: true });
                    return;
                }
                const data = await response.json();
                const quotation = data.quotation || data.Quotation || data;
                const carePlanId = quotation?.care_plan_id ?? quotation?.CarePlanId ?? quotation?.carePlanId ?? null;
                if (!cancelled) {
                    setState({ loading: false, carePlanId: carePlanId || null, error: false });
                }
            } catch (err) {
                console.error('Failed to resolve quotation for shell redirect', err);
                if (!cancelled) setState({ loading: false, carePlanId: null, error: true });
            }
        };

        resolve();
        return () => {
            cancelled = true;
        };
    }, [Qid]);

    if (state.loading) {
        return (
            <div className="container mt-4">
                <LoadingSpinner message="Opening quotation..." />
            </div>
        );
    }

    if (state.carePlanId) {
        return <Navigate to={`/careplans/${id}/${state.carePlanId}/quote/${Qid}`} replace />;
    }

    // No linked service plan (or failed lookup) — fall back to standalone quote page
    return <QuotationDetail />;
}

export default QuotationToShellRedirect;
